import React from "react";

type AuthTextFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: "text" | "email";
  autoComplete?: string;
  hint?: string;
  required?: boolean;
  readOnly?: boolean;
};

export default function AuthTextField({
  label,
  value,
  onChange,
  type = "text",
  autoComplete,
  hint,
  required,
  readOnly = false,
}: AuthTextFieldProps) {
  return (
    <label className="block mb-4">
      <span className="block text-sm font-medium text-slate-700 mb-1.5">
        {label}
      </span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        readOnly={readOnly}
        aria-readonly={readOnly ? "true" : undefined}
        className={`w-full border px-3 py-2.5 text-sm rounded-sm focus:outline-none ${
          readOnly
            ? "border-slate-200 bg-slate-50 text-slate-600 cursor-not-allowed"
            : "border-slate-300 bg-white text-slate-800 focus:ring-2 focus:ring-slate-400 focus:border-slate-400"
        }`}
      />
      {hint && <span className="block text-xs text-slate-500 mt-1">{hint}</span>}
    </label>
  );
}
